<template>
    <div class="view-tasklists">
        <user-menu />
        <div class="wrapper">
               <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>                        
                      <div id="userIdWrapper" style="display:none;">{{lmsUserId}}</div>
                      <div id="pathWrapper" style="display:none;">{{dashboardPath}}</div>
                      
                    </div>

              <div id="learnembed" class="pacificblue" v-if="courseLaunch == 'production' ">
                 <VueScriptComponent script='<script type="text/javascript">var user_id = document.getElementById("userIdWrapper").innerText; var partner_id = 146;var language_id = 1;var dashboard_path = document.getElementById("pathWrapper").innerText;</script><script id="course" charset="utf-8" src="https://www.poweredbyu.com/products/learn/embed/course/embed_course.js"></script>' />            
              </div>

              <div id="learnembed" class="pacificblue" v-else>
                 <VueScriptComponent script='<script type="text/javascript">var user_id = document.getElementById("userIdWrapper").innerText; var partner_id = 146;var language_id = 1;var dashboard_path = document.getElementById("pathWrapper").innerText;</script><script id="course" charset="utf-8" src="https://poweredbyu.uinct.com/products/learn/embed/course/embed_course.js"></script>' />            
              </div>

                   
                </div>   

            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VueScriptComponent from 'vue-script-component'

export default {
    data() {
        return {            
            lmsUserId: '',
            dashboardPath: '',
            courseLaunch: '',
            courseUrl: '',
        }
    },
    components: {
        UserMenu,        
        MasteradminSidebarMenu, 
        VueScriptComponent,       
    },
    methods: {
      redirectDashboard() {
         router.push('/');
      }        
    },
    created() {
      this.courseLaunch = process.env.MM_COURSE_MODE;
      this.courseUrl = process.env.MM_COURSE_URL + 'products/learn/embed/course/embed_course.js';
      this.lmsUserId = this.$route.params.lms_user_id;
      this.dashboardPath = '/' + this.$route.params.dashboard_path;      
    },
    mounted () {
      document.body.classList.add('course-page-bg')
    },
    beforeDestroy() {
      removeLearnComponents();
    }   
}
</script>
<style scoped>
*, *::before, *::after {
  outline: none;
}
.course-page-bg {
   background-color: #FFF;
}
.learn_embed .modal-backdrop {
     z-index: auto !important;
 } 
.learn_embed .modal-header .close {
     margin: 0;
     font-size: 22px;
     padding: 0;
     position: absolute;
     right: 11px;
 }
.container-wrapper {
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mentee/course_display.vue